export const TEXT_FONT = `var(--silka-name, Silka), "Helvetica Neue", Helvetica, sans-serif`;
